"use client";

import React from "react";
import PropTypes from "prop-types";
import Button from "../../../components/Button";
import styles from "./css/paymentCompleteModal.module.css";
import { FiCheck, FiArrowLeft } from "react-icons/fi";

export default function PaymentCompleteModal({
  amountPaid,
  paymentMethod,
  discountApplied,
  onNewSale,
  onClose,
  // Optional configuration props
  title = "Payment Complete!",
  subtitle = "Transaction processed successfully",
  amountLabel = "Amount Paid",
  methodLabel = "Payment Method",
  discountLabel = "Discount Applied",
  primaryLabel = "Start New Sale",
  showDiscount = true,
}) {
  const safeAmount = typeof amountPaid === "number" ? amountPaid : 0;
  const safeDiscount = typeof discountApplied === "number" ? discountApplied : 0;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.panel}>
        <div className={styles.iconCircle}>
          <FiCheck />
        </div>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>

        <div className={styles.rows}>
          <div className={styles.row}>
            <span className={styles.label}>{amountLabel}</span>
            <span className={styles.value}>R {safeAmount.toFixed(2)}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>{methodLabel}</span>
            <span className={styles.value}>{paymentMethod}</span>
          </div>
          {showDiscount && (
            <div className={styles.row}>
              <span className={styles.label}>{discountLabel}</span>
              <span className={styles.value}>R {safeDiscount.toFixed(2)}</span>
            </div>
          )}
        </div>

        <Button
          type="button"
          variant="approve"
          className={styles.primaryButton}
          onClick={onNewSale}
        >
          <FiArrowLeft className={styles.backIcon} />
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
}

PaymentCompleteModal.propTypes = {
  amountPaid: PropTypes.number,
  paymentMethod: PropTypes.string,
  discountApplied: PropTypes.number,
  onNewSale: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  amountLabel: PropTypes.string,
  methodLabel: PropTypes.string,
  discountLabel: PropTypes.string,
  primaryLabel: PropTypes.string,
  showDiscount: PropTypes.bool,
};
